import React from 'react';
import { Upload, X } from 'lucide-react';
import { validateImageRatio, fileToBase64 } from '../utils/helpers';

const CreativeUpload = ({ creative, setCreative, onError, showPreview = true }) => {
  const [uploading, setUploading] = React.useState(false);
  const [warning, setWarning] = React.useState(null);

  const handleFileSelect = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // Check file type
    if (!file.type.startsWith('image/')) {
      onError?.('Please upload an image file');
      return;
    }

    setUploading(true);
    setWarning(null);

    try {
      // Validate image ratio
      const validation = await validateImageRatio(file);
      if (validation.warning) {
        setWarning(validation.warning);
      }

      // Convert to base64
      const base64 = await fileToBase64(file);
      setCreative(base64);
    } catch (error) {
      onError?.(error.message);
    } finally {
      setUploading(false);
    }
  };

  const handleRemove = () => {
    setCreative(null);
    setWarning(null);
  };

  return (
    <div className="space-y-2">
      {!creative ? (
        <label className="block">
          <div className="border-2 border-dashed border-slate-700 rounded-lg p-8 hover:border-indigo-500 transition-colors cursor-pointer">
            <div className="flex flex-col items-center gap-2 text-center">
              <Upload className="w-8 h-8 text-slate-400" />
              <div>
                <p className="text-sm font-medium text-slate-300">
                  Click to upload creative
                </p>
                <p className="text-xs text-slate-500 mt-1">
                  Required: 1:1 ratio (Recommended: 1080x1080)
                </p>
              </div>
              {uploading && <div className="text-xs text-indigo-400">Uploading...</div>}
            </div>
          </div>
          <input
            type="file"
            accept="image/*"
            onChange={handleFileSelect}
            className="hidden"
            disabled={uploading}
          />
        </label>
      ) : (
        <div className="relative">
          <img
            src={creative}
            alt="Campaign creative"
            className="w-full rounded-lg border border-slate-700"
          />
          <button
            onClick={handleRemove}
            className="absolute top-2 right-2 p-2 bg-red-500 hover:bg-red-600 text-white rounded-full shadow-lg transition-colors"
          >
            <X size={16} />
          </button>
        </div>
      )}

      {warning && (
        <div className="p-3 bg-yellow-500/10 border border-yellow-500/20 rounded-lg">
          <p className="text-xs text-yellow-500">⚠️ {warning}</p>
        </div>
      )}
    </div>
  );
};

export default CreativeUpload;
